export default __webpack_public_path__ + "static/media/trade-in-inr.bce6b6af.svg";